<template>
  <div id="app" v-cloak v-show="test">
    <Hearder v-show="$route.path !='/login' && $route.path !='/register' && $route.path !='/passwordRetrieval'" />
    <router-view :class="{'main-wrapper':$route.path !='/login' && $route.path !='/register' && $route.path !='/passwordRetrieval'}"></router-view>
    <!-- <Footer v-show="test02" /> -->
    <Footer v-show="test02 && $route.path !='/index' && $route.path !='/productservice' && $route.path !='/login' && $route.path !='/register' && $route.path !='/passwordRetrieval'" />
  </div>
</template>

<script>
import Hearder from "./components/Hearder.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "App",
  components: {
    Hearder,
    Footer,
  },
  data(){
    return{
      test:false,
      test02:false
    }
  },
  mounted(){
    setTimeout(()=>{
      this.test = true;
    },10)
    setTimeout(()=>{
      this.test02 = true;
    },100)
  }
};
</script>

<style lang="scss" scoped>
[v-cloak]{
    display: none;
  }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.main-wrapper{
  margin-top: 60px;
  overflow: hidden;
}

// 移动端
@media screen and (min-width: 300px) and (max-width: 760px) {
  [v-cloak]{
    display: none;
  }
  .main-wrapper{
    margin-top: 40px;
  }
}
</style>
